
import { format, parse } from "date-fns";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "DateTime",
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Date as PropType<Date | null>,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    timeDisabled: {
      type: Boolean,
      required: false,
    },
    cls: {
      type: String,
      required: false,
    },
    maxDate: {
      type: Date,
      required: false,
    },
    dateLabel: {
      type: String,
      required: false,
    },
    timeLabel: {
      type: String,
      required: false,
    },
  },
  emits: ["changed"],
  data() {
    return {
      dateText: "",
      timeText: "",
    };
  },
  mounted() {
    this.initializeDateAndTimeText();
  },
  watch: {
    value() {
      this.initializeDateAndTimeText();
    },
  },
  methods: {
    initializeDateAndTimeText() {
      if (this.value) {
        this.dateText = this.formatDate(this.value);
        this.timeText = this.formatTime(this.value);
      }
    },
    handleDateAndTimeChange() {
      const date =
        this.dateText && this.timeText
          ? parse(`${this.dateText} ${this.timeText}`, "yyyy-MM-dd HH:mm", this.value || new Date())
          : null;
      this.$emit("changed", date);
    },
    formatDate(date: Date | null | undefined) {
      return date ? format(date, "yyyy-MM-dd") : "";
    },
    formatTime(date: Date | null | undefined) {
      return date ? format(date, "HH:mm") : "";
    },
  },
});
